import { Box } from 'native-base';
import { LinearGradient } from 'expo-linear-gradient';
import { theme } from '@breakroom-nx/assets';

export interface GradientProps {
  height?: string | number;
  locations?: number[]; // Location of Gradient Color Endpoints
  colors?: string[]; // RGBA
  mt?: string | number;
  mb?: string | number;
  style?: any;
}

export const Gradient = ({
  height = '20px',
  locations = [0, 1],
  colors = [theme.colors.surface[100], 'transparent'],
  mt = 0,
  mb = 0,
  style,
}: GradientProps) => {
  return (
    <Box width={'full'} zIndex={9999} mb={mb} mt={mt} style={style}>
      <LinearGradient locations={locations} colors={colors}>
        <Box height={height} />
      </LinearGradient>
    </Box>
  );
};
